<div class="admin-container">
  <h2>Administración de Roles</h2>
  
  <div class="actions-top">
    <button (click)="createNewRole()" class="btn-add">Nuevo Rol</button>
  </div>
  
  <div class="table-container" *ngIf="!selectedRole">
    <div class="loader" *ngIf="loading">Cargando...</div>
    
    <table *ngIf="!loading && roles.length > 0">
      <thead>
        <tr>
          <th>Nombre</th>
          <th>Descripción</th>
          <th>Permisos</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let role of roles">
          <td>{{ role.name }}</td>
          <td>{{ role.description }}</td>
          <td>{{ role.permissions?.join(', ') || 'Sin permisos' }}</td>
          <td class="actions-column">
            <button (click)="editRole(role)" class="btn-edit">Editar</button>
            <button (click)="deleteRole(role)" class="btn-delete">Eliminar</button>
          </td>
        </tr>
      </tbody>
    </table>
    
    <div class="empty-state" *ngIf="!loading && roles.length === 0">
      No hay roles definidos. Haga clic en "Nuevo Rol" para crear uno.
    </div>
  </div>
  
  <div class="role-form" *ngIf="selectedRole">
    <h2>{{ isNewRole ? 'Crear Nuevo Rol' : 'Editar Rol' }}</h2>
    
    <div class="form-group">
      <label>Nombre:</label>
      <input type="text" [(ngModel)]="selectedRole.name" />
    </div>
    
    <div class="form-group">
      <label>Descripción:</label>
      <input type="text" [(ngModel)]="selectedRole.description" />
    </div>
    
    <div class="form-group">
      <label>Permisos (separados por coma):</label>
      <input type="text" [(ngModel)]="selectedRole.permissions" />
      <small class="help-text">Ejemplo: crear_usuarios, editar_usuarios, ver_dashboard</small>
    </div>
    
    <div class="actions">
      <button (click)="saveRole()" class="btn-save">Guardar</button>
      <button (click)="cancelEdit()" class="btn-cancel">Cancelar</button>
    </div>
  </div>
</div> 